import { Ticket, TicketType } from "types";

export const getVoucherCode = (tickets: Ticket[], defaultValue = ""): string => {
    let code = null;

    for (const ticket of tickets) {
        switch (ticket.type) {
            case TicketType.VOUCHER:
            case TicketType.AFFILIATE:
            case TicketType.OTA:
                code = ticket.code;
                break;
            case TicketType.XOLA:
                continue;
            default: // Do nothing
                return defaultValue;
        }
    }

    return code ?? defaultValue;
};

export const getOTATicketCode = (tickets: Ticket[]) => {
    return tickets.find((ticket) => ticket.type === TicketType.OTA)?.code ?? "";
};

export const getAffiliateTicketCode = (tickets: Ticket[]) => {
    return tickets.find((ticket) => ticket.type === TicketType.AFFILIATE)?.code ?? "";
};
